import { useMountEffect } from './useMountEffect';

export const useLoadContextEffect = (dispatch, value) => {
  useMountEffect(() => {
    dispatch((a) => {
      return { ...a, ...value };
    });
  });
};

export default useLoadContextEffect;
